import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import SearchBar from "./components/SearchBar";
import WeatherCard from "./components/WeatherCard";
import ForecastStrip from "./components/ForecastStrip";
import Footer from "./components/Footer";

const API_KEY = "4c2d34edtb05a9b0ao32170dd17e08f4";

export default function App() {
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState([]);
  const [unit, setUnit] = useState("C");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // 🔑 Fetch current weather by city name
  function searchCity(city) {
    setLoading(true);
    setError("");
    const url = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${API_KEY}&units=metric`;
    axios
      .get(url)
      .then((response) => {
        setWeather(response.data);
        setUnit("C");
        fetchForecast(response.data.coordinates);
      })
      .catch(() => {
        setError(`City "${city}" not found. Please try again.`);
        setLoading(false);
      });
  }

  // 🔑 Fetch forecast by coordinates
  function fetchForecast(coordinates) {
    const url = `https://api.shecodes.io/weather/v1/forecast?lat=${coordinates.latitude}&lon=${coordinates.longitude}&key=${API_KEY}&units=metric`;
    axios.get(url).then((response) => {
      setForecast(response.data.daily);
      setLoading(false);
    });
  }

  // 🔑 Fetch by geolocation
  function searchByLocation() {
    setLoading(true);
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      const url = `https://api.shecodes.io/weather/v1/current?lat=${latitude}&lon=${longitude}&key=${API_KEY}&units=metric`;
      axios.get(url).then((response) => {
        setWeather(response.data);
        setUnit("C");
        fetchForecast(response.data.coordinates);
      });
    });
  }

  // Load Asunción on startup
  useEffect(() => {
    searchCity("Asunción");
  }, []);

  return (
    <div className="app">
      <SearchBar onSearch={searchCity} onLocate={searchByLocation} />

      {error && <p style={{ color: "#ffb3b3", marginBottom: 16, textAlign: "center" }}>{error}</p>}

      <WeatherCard
        weather={weather}
        unit={unit}
        onUnitChange={setUnit}
        loading={loading}
      />

      {!loading && forecast.length > 0 && (
        <ForecastStrip forecast={forecast} unit={unit} />
      )}

      <Footer />
    </div>
  );
}
